module.exports = __webpack_public_path__ + "img/icon-50.32b55924.png";